<div class="confirm-modal-wrapper">
    <h2>{{confirmationMessage}}</h2>
    <button class="btn btn-amazon-default-md btn-amazon-outline mr-15" (click)="closeModal('cancel')">{{cancelButtonLabel}}</button>
    <button class="btn btn-amazon-md btn-amazon-outline" (click)="closeModal('success')">{{successButtonLabel}}</button>
  </div>